/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { TGenericModelNode } from "@adapptio/lib-blueprint";
import { IInspectorControls, TInspectorControlComponent } from "../InspectorTypes";
import { useBlueprintModel } from "../../../hooks/useBlueprintModel";
import { InvalidModelNode } from "../InvalidModelNode";
import { ISchemaConstSecretModel } from "@adapptio/lib-blueprint/src/schemas/const/SchemaConstSecret";
import { FieldSecret } from "../../Fields/FieldSecret";
import { useEditorInspectorContext } from "../../../contexts/EditorInspectorContext";

export const ControlConstSecret_Primary: TInspectorControlComponent<ISchemaConstSecretModel> = ({
	model: _model
}) => {
	const { model, validationErrors } = useBlueprintModel(_model, "constSecret");

	const inspectorContext = useEditorInspectorContext();

	const handleChange = useCallback(
		(value: string) => {
			if (!model) {
				return;
			}

			model.schema.setValue(model, value, true);
		},
		[ model ]
	);

	if (!model) {
		return <InvalidModelNode model={_model} />;
	}

	return (
		<FieldSecret
			onChange={handleChange}
			secretKey={model.value}
			validationErrors={validationErrors}
			grow={true}
			readOnly={inspectorContext?.readOnly}
		/>
	);
};

export const ControlConstSecret = (model: TGenericModelNode): IInspectorControls => ({
	primary: {
		component: ControlConstSecret_Primary,
		model: model
	}
});
